export const faqData = [
  {
    id: 1,
    question: "What is the maximum tenure for a home loan with HDFC?",
    answer:
      "The maximum loan tenure for a home loan with HDFC is 30 years, but the tenure depends on the applicant’s age and income.",
  },
  {
    id: 2,
    question:
      "Does the HDFC EMI Calculator include processing fees and other charges?",
    answer:
      "The calculator estimates only the EMI amount based on the loan amount, interest rate, and tenure. It does not include processing fees, stamp duties, or other incidental charges. You should verify the exact fees with HDFC.",
  },
  {
    id: 3,
    question:
      "Can I adjust the loan tenure or amount after calculating the EMI?",
    answer:
      "Yes, the tool allows you to adjust the loan amount, tenure, and interest rate to understand how changes affect your EMI and total repayment.",
  },
];
